// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   apiBaseUrl: 'https://dev.api-frank.parking.ldcs.ae',
//   myFatoorahBaseUrl: 'https://dev.api-frank.parking.ldcs.ae/my-fatoorah',
//   stripeBaseUrl: 'https://dev.api-frank.parking.ldcs.ae/stripe'
// };

export const environment = {
  production: true,
  apiBaseUrl: 'https://api.parking.ldcs.ae',
  myFatoorahBaseUrl: 'https://api.parking.ldcs.ae/my-fatoorah',
  stripeBaseUrl: 'https://api.parking.ldcs.ae/stripe'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
